import { render, staticRenderFns } from "./ContractCommissionPostingsList.vue?vue&type=template&id=06f225d2&scoped=true"
import script from "./ContractCommissionPostingsList.vue?vue&type=script&lang=js"
export * from "./ContractCommissionPostingsList.vue?vue&type=script&lang=js"
import style0 from "./ContractCommissionPostingsList.vue?vue&type=style&index=0&id=06f225d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f225d2",
  null
  
)

export default component.exports